import { createDiscountType, discountListType, insuranceListType, searchParamsType } from "./types";
import { ResponseType } from "../../../Types/ServicesType/servicesType";
import api from "@services/apiList";
import instance from "@services/services";
const {MastersApi}=api

export const insuranceList = async (params: searchParamsType): Promise<ResponseType<{items:insuranceListType[],totalRecords:number}>> => {
    const result = await instance.post(api.MastersApi.getAllDiscountInsurance, params);
    return result.data;
}

export const createDiscount = async (params: createDiscountType): Promise<ResponseType<string>> => {
    const result = await instance.post(MastersApi.AddorEditDiscount, params);
    return result.data;
}

export const deleteDiscount = async (id: number): Promise<ResponseType<string>> => {
    const result = await instance.delete(`${MastersApi.deleteDiscount}${id}`);
    return result.data;
}
export const getDiscountById = async (params:{id: number,clinicId:number}): Promise<ResponseType<{totalCount:number,items:discountListType[]}>> => {
    const result = await instance.get(`${MastersApi.findDiscount}${params.clinicId}?insuranceId=${params.id}`);
    return result.data;
}